import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from './base-query';

const notificationAPI = createApi({
    reducerPath: 'notificationAPI',
    baseQuery,
    endpoints: (builder) => ({
        getNotificationSettings: builder.mutation({
            query: () => ({
                url: "admin/notification-settings",
                method: "GET",
            }),
            transformResponse: (response) => response,
            providesTags: ['Notification'],
        }),

        updateNotificationSettings: builder.mutation({
            query: ({ body }) => ({
                url: "admin/notification-settings",
                method: "PUT",
                body,
            }),
            transformResponse: (response) => response,
            invalidatesTags: ['Notification'],
        }),

        //notifications
        getNotifications: builder.mutation({
            query: ({ page = 0, size = 10 } = {}) => ({
                url: `notifications?page=${page + 1}&size=${size}`,
                method: "GET",
            }),
            transformResponse: (response) => response,
            providesTags: ['notifications']
        }),
        
        markNotificationAsRead: builder.mutation({
            query: ({ id }) => ({
                url: `notifications/${id}/read`,
                method: "PATCH",
                body: {},
            }),
            transformResponse: (response) => response
        }),

        markAllNotificationsAsRead: builder.mutation({
            query: () => ({
                url: "notifications/read-all",
                method: "PATCH",
                body: {},
            }),
            transformResponse: (response) => response
        }),

        deleteNotification: builder.mutation({
            query: ({ id }) => ({
                url: `notifications/${id}`,
                method: "DELETE",
                body: {},
            }),
            transformResponse: (response) => response
        }),
    }),
});

export const {
    useGetNotificationSettingsMutation,
    useUpdateNotificationSettingsMutation,

    //notifications
    useGetNotificationsMutation,
    useMarkNotificationAsReadMutation,
    useMarkAllNotificationsAsReadMutation,
    useDeleteNotificationMutation,
} = notificationAPI;

export default notificationAPI;